/* Editor de ubicación
Datos básicos: nombre, limites, tipo */
import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, Select, MenuItem, Box, Typography} from '@mui/material';

const EditZonaModal = ({ open, onClose, zona, onSave }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    limitePorPersona: 1,
    limiteMaximo: 50,
    tipoUbicacion: 1
  });

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    onClose();
  };

  useEffect(() => {
    if (zona) {
      setFormData({
        nombre: zona.ubicacion || '',
        limitePorPersona: zona.limite_persona || 1,
        limiteMaximo: zona.limite_maximo || 50,
        tipoUbicacion: zona.tipo_ubicacion || 1
      });
    }
  }, [zona]);

  const handleSave = () => {
    onSave(formData);
  };

  if (!zona) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{
      sx: {
        borderRadius: '10px',
        boxShadow: '0 8px 32px rgba(44, 62, 80, 0.12)',
        bgcolor: '#ffff',
        p: 2
      }
    }}>
      <DialogTitle sx={{
        pb: 2,
        fontWeight: 700,
        fontSize: '18px',
        color: '#0b0060',
        borderBottom: '1px solid #E4E4E7',
        mb: 2
      }}>
        Editar Zona - {zona.ubicacion}
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
          <Typography variant="p" sx={{ mb: 0, color: "#0b0062" }}>Nombre de la zona</Typography>
          <TextField
            sx={{
              fontFamily: "Bricolage Grotesque",
              backgroundColor: "#ffff",
              mb: 1,
              '& .MuiInputBase-input-MuiOutlinedInput-input': {
                fontFamily: "Bricolage Grotesque",
              },
              '& label.Mui-focused': {
                color: '#5656FF',
                fontFamily: "Bricolage Grotesque"
              },
              '& .MuiOutlinedInput-root': {
                height: "40px",
                '& fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&:hover fieldset': {
                  borderColor: '#5656ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#5656ff',
                },
              }
            }}
            value={formData.nombre}
            onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
            fullWidth
          />

          <Typography variant="p" sx={{ mb: 0, color: "#0b0062" }}>Límite de compra por persona</Typography>
          <TextField
            type="number"
            value={formData.limitePorPersona}
            onChange={(e) => setFormData({ ...formData, limitePorPersona: parseInt(e.target.value) || 1 })}
            fullWidth
            sx={{
              fontFamily: "Bricolage Grotesque",
              backgroundColor: "#ffff",
              mb: 1,
              '& .MuiInputBase-input-MuiOutlinedInput-input': {
                fontFamily: "Bricolage Grotesque",
              },
              '& label.Mui-focused': {
                color: '#5656FF',
                fontFamily: "Bricolage Grotesque"
              },
              '& .MuiOutlinedInput-root': {
                height: "40px",
                '& fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&:hover fieldset': {
                  borderColor: '#5656ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#5656ff',
                },
              }
            }}
            inputProps={{ min: 1 }}
          />

          <Typography variant="p" sx={{ mb: 0, color: "#0b0062" }}>Límite máximo de personas</Typography>
          <TextField
            sx={{
              fontFamily: "Bricolage Grotesque",
              backgroundColor: "#ffff",
              mb: 1,
              '& .MuiInputBase-input-MuiOutlinedInput-input': {
                fontFamily: "Bricolage Grotesque",
              },
              '& label.Mui-focused': {
                color: '#5656FF',
                fontFamily: "Bricolage Grotesque"
              },
              '& .MuiOutlinedInput-root': {
                height: "40px",
                '& fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&:hover fieldset': {
                  borderColor: '#5656ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#5656ff',
                },
              }
            }}
            type="number"
            value={formData.limiteMaximo}
            onChange={(e) => setFormData({ ...formData, limiteMaximo: parseInt(e.target.value) || 1 })}
            fullWidth
            inputProps={{ min: 1 }}
          />

          <FormControl fullWidth sx={{
            minWidth: 200,
            '& .MuiOutlinedInput-root': {
              fontFamily: "Bricolage Grotesque",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
              height: "40px",
            },
            '& .MuiFormHelperText-root': {
              fontFamily: "Bricolage Grotesque",
            }
          }}>
            <Typography variant="p" sx={{ mb: 0.5, color: "#0b0062" }}>Tipo de ubicación</Typography>
            <Select
              sx={{
                backgroundColor: "#ffff",
                '& .MuiSelect-select': {
                  padding: "8px 14px",
                  display: 'flex',
                  alignItems: 'center',
                  height: "24px",
                  width: "100%",
                }
              }}
              value={formData.tipoUbicacion}
              onChange={(e) => setFormData({ ...formData, tipoUbicacion: e.target.value })}
            >
              <MenuItem value={1}>General</MenuItem>
              <MenuItem value={2}>Con mesas</MenuItem>
              <MenuItem value={3}>Con filas de asientos</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button sx={{
          borderRadius: '8px',
          bgcolor: '#fff',
          color: '#1e293b',
          fontWeight: 600,
          px: 3,
          py: 1,
          mr: 2,
          border: '1px solid #E4E4E7',
          '&:hover': { bgcolor: '#f1f5f9' }
        }} onClick={onClose}>Cancelar</Button>
        <Button
          sx={{
            bgcolor: '#6366f1',
            borderRadius: '10px',
            fontWeight: 600,
            '&:hover': { bgcolor: '#4f46e5' },
            '&:disabled': {
              bgcolor: '#e5e7eb',
              color: '#9ca3af'
            },
            px: 3,
            py: 1,
            boxShadow: '0 1px 3px rgba(44,62,80,0.07)',
          }}
          onClick={handleSave} variant="contained">
          Guardar Cambios
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditZonaModal;